import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    Button, Grid, Modal, Textblock, Formatter,
} from 'framework-ui-components';

import { dettaglioBarra4 } from 'apis/setteTrentaApi';

const FORM_INITIAL_STATE = {
    IdDichiarazione: '',
    Dichiarante: '',
    CodiceFiscaleSostitutoImposta: '',
    Trattenuta: 0,
    Rimborso: 0,
    Stato7304: '',
    ModalitaInvio: '',
    Note: '',
    DataTrasmissioneCgn: null,
    DataTrasmissioneAE: null,
    ProtocolloInvioAE: '',
    EsitoInvioAE: '',
    DataEsitoInvioAE: null,
    NomeFileEsito: '',
    DataInvioPostel: null,
    Scarto7304: '',
    DataRicezioneScarto: null,
    NomeFileScarto: '',
    NoteScarto: '',
    Scarto: false,
};

class DettaglioBarra4 extends Component {
    state = {
        ...FORM_INITIAL_STATE,
        isLoadingInternal: false,
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.showModal && this.props.showModal != nextProps.showModal) {
            this.caricaDettaglioBarra4(nextProps.idDichiarazione);
        }
    }

    caricaDettaglioBarra4(idDichiarazione) {
        this.setState({
            isLoadingInternal: true,
        }, () => {
            dettaglioBarra4(idDichiarazione, this.props.annoSelezionato)
                .then((res) => {
                    if (res) {
                        this.setState({
                            ...res,
                            isLoadingInternal: false,
                        });
                    } else {
                        this.setState({
                            ...FORM_INITIAL_STATE,
                            isLoadingInternal: false,
                        });
                    }
                });
        });
    }

    chiudi = () => {
        this.setState(FORM_INITIAL_STATE, () => this.props.onChiudi && this.props.onChiudi());
    }

    render() {
        const {
            showModal,
        } = this.props;
        const {
            Dichiarante, Trattenuta, Rimborso, Stato7304, ModalitaInvio,
            Note, DataTrasmissioneCgn, DataTrasmissioneAE, ProtocolloInvioAE, EsitoInvioAE,
            DataEsitoInvioAE, DataRicezioneScarto, NoteScarto,
            Scarto, isLoadingInternal, CodiceFiscaleSostitutoImposta, DataInvioPostel
        } = this.state;

        const senzaSostituto = CodiceFiscaleSostitutoImposta == '';
        const label = Scarto ? 'Scarto 730/4' : 'Esito 730/4';


        return (
            <Modal show={showModal} onClose={this.chiudi} loading={isLoadingInternal} className="dettaglioBarra4Dialog">
                <Modal.Header>Dettaglio 730/4</Modal.Header>
                <Modal.Body>
                    <Grid fluid>
                        <Grid.Row>
                            <Grid.Col md="12">
                                <Textblock text={Dichiarante} label="Dichiarante" />
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Col md="6">
                                <Textblock text={<span><Formatter tipo="currency" valore={Trattenuta} /> &euro;</span>} label="Trattenuto" />
                            </Grid.Col>
                            <Grid.Col md="6">
                                <Textblock text={<span><Formatter tipo="currency" valore={Rimborso} /> &euro;</span>} label="Rimborsato" />
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Col md="6">
                                <Textblock text={Stato7304} label="Stato" />
                            </Grid.Col>
                            <Grid.Col md="6">
                                <Textblock text={ModalitaInvio} label="Modalità invio" />
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Col md="12">
                                <Textblock text={Note} label="Note" />
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Col md="6">
                                <Textblock text={<Formatter tipo="date" valore={DataTrasmissioneCgn} />} label="Data trasmissione CGN" />
                            </Grid.Col>
                            <Grid.Col md="6">
                                <Textblock text={<Formatter tipo="date" valore={DataTrasmissioneAE} />} label="Data trasmissione A.E." />
                            </Grid.Col>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Col md="6">
                                <Textblock text={ProtocolloInvioAE} label="Protocollo invio A.E." />
                            </Grid.Col>
                            <Grid.Col md="6">
                                <Textblock text={<Formatter tipo="date" valore={DataEsitoInvioAE} />} label="Data esito invio A.E." />
                            </Grid.Col>
                        </Grid.Row>
                        {!senzaSostituto
                            && (
                                <Grid.Row>
                                    <Grid.Col md="6">
                                        <Textblock text={EsitoInvioAE} label={label} />
                                    </Grid.Col>
                                    <Grid.Col md="6">
                                        <Textblock text={<Formatter tipo="date" valore={DataRicezioneScarto} />} label="Data esito 730/4" />
                                    </Grid.Col>
                                </Grid.Row>
                            )
                        }
                        {!senzaSostituto
                            && (
                                <Grid.Row>  
                                    <Grid.Col md="12">
                                        <Textblock text={NoteScarto} label="Note scarto 730/4" />
                                    </Grid.Col>
                                </Grid.Row>
                            )
                        }
                        { DataInvioPostel!=null && 
                            <Grid.Row>
                                <Grid.Col md="6">
                                    <Textblock text={<Formatter tipo="date" valore={DataInvioPostel} />} label="Data invio Postel" />
                                </Grid.Col>
                            </Grid.Row>
                        }
                    </Grid>
                </Modal.Body>
                <Modal.Footer>
                    <Button flat primary onClick={this.chiudi}>Chiudi</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

DettaglioBarra4.propTypes = {
    idDichiarazione: PropTypes.string.isRequired,
    onChiudi: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    annoSelezionato: PropTypes.number,
};

export default DettaglioBarra4;
